import { V2BannerCreateRequestDtoCategory as BannerCategory, V2BannerCreateRequestDtoLinkType as LinkType, V2BannerCreateRequestDtoPositionsItem as PositionsItem } from "@everon-it/api-client/contents-gw";
import { type UploadSize } from "@components/atoms/Upload";
import { type BasicOptionType } from "@components/atoms/CheckBox";
import { CommonElementType } from "@utils/DynamicComponentUtils";
import { type CommonContentsRenderType, type CommonCreateBodyKeyType, type CommonDataType } from "src/types/common";

export type BannerCreateInitValuesType = {
    category: BannerCategory;
    displayStartAt: string;
    displayEndAt: string;
    isVisible: boolean;
    title: string;
    imageUrl: string;
    linkType: LinkType;
    linkTargetId: string | null;
    linkUrl: string;
    displayOrder: number;
    linkTargetDisplayStartAt?: string;
    linkTargetDisplayEndAt?: string;
    positions: string[];
    linkTargetTitle?: string | null;
};

export type BannerCommonContentsOptionType = {
    placeholder?: string;
    secondPlaceholder?: string;
    secondName?: string;
    isSizeQuestion?: boolean;
    size?: UploadSize;
    hasKeywordToShowContent?: string;
    options?: BasicOptionType[];
} & Omit<CommonContentsRenderType, "options">;

export const BannerCreateData: CommonDataType<CommonCreateBodyKeyType, BannerCreateInitValuesType, BannerCommonContentsOptionType> = {
    createBodyKey: ["category", "displayStartAt", "displayEndAt", "isVisible", "title", "imageUrl", "linkType", "linkTargetId", "linkUrl", "displayOrder", "positions"],
    formInitialValues: {
        category: BannerCategory.POPUP,
        displayStartAt: "",
        displayEndAt: "",
        isVisible: false,
        title: "",
        imageUrl: "",
        linkType: LinkType.NOTICE,
        linkTargetId: null,
        linkUrl: "",
        displayOrder: 0,
        linkTargetDisplayStartAt: "",
        linkTargetDisplayEndAt: "",
        positions: [],
    },
    contentsOption: [
        {
            label: "배너종류",
            name: "category",
            type: CommonElementType.RADIO,
            options: [
                { label: "토스트 팝업", value: BannerCategory.POPUP },
                { label: "띠 배너", value: BannerCategory.BANNER },
            ],
        },
        {
            label: "분류",
            name: "positions",
            type: CommonElementType.CHECK_BOX,
            hasKeywordToShowContent: BannerCategory.BANNER,
            options: [
                {
                    label: "전체",
                    value: "ALL",
                },
                {
                    label: "홈",
                    value: PositionsItem.MAIN,
                },
                {
                    label: "포인트 충전하기",
                    value: PositionsItem.PREPAID,
                },
                {
                    label: "충전권 선물하기",
                    value: PositionsItem.GIFT,
                },
            ],
        },
        {
            label: "게시 기간",
            name: "displayStartAt",
            secondName: "displayEndAt",
            type: CommonElementType.DATE_RANGE_PICKER,
            placeholder: "날짜를 입력해주세요",
            secondPlaceholder: "날짜를 입력해주세요",
        },
        {
            label: "노출 상태",
            name: "isVisible",
            type: CommonElementType.TOGGLE,
        },
        {
            label: "제목(관리자용)",
            name: "title",
            type: CommonElementType.INPUT,
            placeholder: "팝업 제목을 입력해주세요",
        },
        {
            label: "팝업 이미지",
            name: "imageUrl",
            type: CommonElementType.IMAGE_UPLOAD,
            size: "large",
            isSizeQuestion: true,
        },
    ],
};
